export enum EUserDocumentType {
    CPF = 'CPF',
    RG = 'RG',
    CNH = 'CNH',
    PIS = 'PIS',
    CTPS = 'CTPS',
    TITULO_ELEITOR = 'TITULO_ELEITOR',
    RESERVISTA = 'RESERVISTA',
    OTHER = 'OTHER',
}

export const USER_IDENTITY_DOCUMENT_TYPES: EUserDocumentType[] = [
    EUserDocumentType.CPF,
    EUserDocumentType.RG,
    EUserDocumentType.CNH,
];

export const USER_LABOR_DOCUMENT_TYPES: EUserDocumentType[] = [
    EUserDocumentType.PIS,
    EUserDocumentType.CTPS,
    EUserDocumentType.TITULO_ELEITOR,
    EUserDocumentType.RESERVISTA,
    EUserDocumentType.OTHER,
];
